import { IntlShape } from "react-intl";

const PAYMENT_STATUS_OPTIONS = (intl: IntlShape) => [
  {
    value: "submitted",
    label: intl.formatMessage({
      id: "general.submitted",
      defaultMessage: "Submitted",
    }),
  },
  {
    value: "processing",
    label: intl.formatMessage({
      id: "general.processing",
      defaultMessage: "Processing",
    }),
  },
  {
    value: "paid",
    label: intl.formatMessage({
      id: "general.paid",
      defaultMessage: "Paid",
    }),
  },
  {
    value: "rejected",
    label: intl.formatMessage({
      id: "general.rejected",
      defaultMessage: "Rejected",
    }),
  },
  {
    value: "verified",
    label: intl.formatMessage({
      id: "general.verified",
      defaultMessage: "Verified",
    }),
  },
];

export default PAYMENT_STATUS_OPTIONS;
